import fetch from 'cross-fetch';
import { ApiV1Base, ApiPrefix, statusCheck, json, getCookie } from '../util/icwUtility';
import { actLoginTimedOut } from './loginStateActions';

//
//  ******* In-memory updated Related *******
//
export const DASHBOARD_INIT = 'DASHBOARD_INIT';
export function actDashboardInit() {
  return { type: DASHBOARD_INIT };
}

//
//  ******* Fetch Job Quote Num. Begin *******
//
export const DASHBOARD_JOB_FETCH_BEGIN = 'DASHBOARD_JOB_FETCH_BEGIN';
function actDashBoardJobBegin() {
  return { type: DASHBOARD_JOB_FETCH_BEGIN };
}

export const DASHBOARD_JOB_FETCH_SUCCESS = 'DASHBOARD_JOB_FETCH_SUCCESS';
export function actDashBoardJobSuccess(data) {
  return { type: DASHBOARD_JOB_FETCH_SUCCESS, data };
}

export const DASHBOARD_JOB_FETCH_FAIL = 'DASHBOARD_JOB_FETCH_FAIL';
function actDashBoardJobFail(reason) {
  return { type: DASHBOARD_JOB_FETCH_FAIL, reason };
}

export function actDashBoardJobFetch() {
  return (dispatch) => {
    dispatch(actDashBoardJobBegin());
    return fetch(`${ApiV1Base}${ApiPrefix}/dashboard`, {
      headers: { Authorization: getCookie('token') },
    })
      .then(statusCheck)
      .then(json)
      .then((res) => dispatch(actDashBoardJobSuccess(res)))
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actDashBoardJobFail(typeof err === 'object' ? err.message : err));
      });
  };
}

//
//  ******* Fetch Job Quote Num. End *******
//

//
//  ******* Update DashBoard Jobs with Filter Key Begin *******
//
export const DASHBOARD_JOB_UPDATE_BEGIN = 'DASHBOARD_JOB_UPDATE_BEGIN';
function actDashBoardJobUpdateBegin() {
  return { type: DASHBOARD_JOB_UPDATE_BEGIN };
}

export const DASHBOARD_JOB_UPDATE_SUCCESS = 'DASHBOARD_JOB_UPDATE_SUCCESS';
export function actDashBoardJobUpdateSuccess(data, filterValue) {
  return { type: DASHBOARD_JOB_UPDATE_SUCCESS, data, filterValue };
}

export const DASHBOARD_JOB_UPDATE_FAIL = 'DASHBOARD_JOB_UPDATE_FAIL';
function actDashBoardJobUpdateFail(reason) {
  return { type: DASHBOARD_JOB_UPDATE_FAIL, reason };
}

export function actDashBoardJobUpdate(type, key) {
  return (dispatch, getState) => {
    dispatch(actDashBoardJobUpdateBegin());
    return fetch(`${ApiV1Base}${ApiPrefix}/dashboard`, {
      method: 'POST',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ type, key }),
    })
      .then(statusCheck)
      .then(json)
      .then((json) => dispatch(actDashBoardJobUpdateSuccess(json, type)))
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actDashBoardJobUpdateFail(typeof err === 'object' ? err.message : err));
      });
  };
}

//
//  ******* Update DashBoard Jobs with Filter Key End *******
//
